// constant.jsx
// import image1 from './../assets/images/home_bf_image1.jpg';
// import image2 from './../assets/images/home_bf_image2.jpg';
import image3 from './../assets/images/home_bf_image3.jpg';
import image4 from './../assets/images/home_bf_image4.jpg';
import image5 from './../assets/images/home_bf_image5.jpg';
// import image6 from './../assets/images/home_bf_image6.jpg';
import image7 from './../assets/images/home_bf_image7.jpg';
import image8 from './../assets/images/home_bf_image8.jpg';
import image9 from './../assets/images/home_bf_image9.jpg';
import image10 from './../assets/images/home_bf_image10.jpg';
import image11 from './../assets/images/home_bf_image11.jpg';
import advancedhair from './../assets/images/advance_hair.jpg';
import advanceskincare from './../assets/images/Advance_skin_care.jpg';
import dentalcosmetology from './../assets/images/Dental_cosmetology.jpg';
import spoorthi from './../assets/images/doctorsDr.SpoorthiPrasad.png';
import renuka from './../assets/images/doctorsDR.Renuka.png';
import jyothi from './../assets/images/doctorsDr.Jyothi.png';
import hari from './../assets/images/doctorsdDr.harikrishna.png';
import nelofar from './../assets/images/doctorsDr.nelofar.png';
import priyanka from './../assets/images/doctorsDr.priyanka.png';
import bargavi from './../assets/images/doctorsDr.Bhargavi.png'

  export const members = [
    // { id: 1,  image:image1 , link: "/treatment1" },
    // { id: 2,  image:image2 , link: "/treatment2" },
    { id: 3,  image: image3, link: "https://www.instagram.com/p/DA7pkTezzPO/?igsh=dW4zcWV3ZTRtNDc3" },
    { id: 4,  image: image4, link: "https://www.instagram.com/p/DCGNawut-XJ/?igsh=MWh4bGI3aWpqbXA3ag==" },
    { id: 5,  image:image5 , link: "https://www.instagram.com/p/DCwKM5PiCRe/" },
    // { id: 6,  image:image6 , link: "/treatment2" },
    { id: 7,  image: image7, link: "https://www.instagram.com/p/DBdAtLbJuYp/?igsh=YTBzMHJ3eDE1OTM2" },
    { id: 8,  image: image8, link: "https://www.instagram.com/p/DDle089Cinz/?igsh=MXBnZGhlY3prZjBuaw%3D%3D" },
    { id: 9,  image: image9, link: "https://www.instagram.com/p/DDJTQrozIWz/?igsh=MWNrNDBlMmhtdWtpNA%3D%3D" },
    { id: 10,  image: image10, link: "https://www.instagram.com/p/DBTYaDIzhnZ/?igsh=NW9vcTZmZWp5MDE2 " },
    { id: 11,  image: image11, link: "https://www.instagram.com/p/DAcvDvnzEHL/?igsh=MXAycDBxN2Q5dXRhNQ==" },
    
  ];
  export const videos = [
    { id: 1, src: "https://www.youtube.com/embed/Pt8ryQPe-6I",title:"Thyroid Wellness with H-Cura!"  },
    { id: 2, src: "https://www.youtube.com/embed/9SFevdXPRLI", title: "Deep skin analysis with H-Cura" }

  ]
  export const faqs = [
    {
      question: "What is homeopathy?",
      answer:
        "Homeopathy is a system of alternative medicine that uses small doses of natural substances to stimulate the body’s healing process.",
    },
    {
      question: "How does homeopathy work?",
      answer:
        "Homeopathy works by triggering the body's natural healing responses to symptoms of illness through the use of diluted natural substances.",
    },
    {
      question: "Is homeopathy safe?",
      answer:
        "Yes, homeopathy is considered safe when prescribed by a qualified practitioner and used correctly.",
    },
    {
      question: "Can homeopathy cure chronic diseases?",
      answer:
        "Homeopathy is often used to treat chronic conditions, improving overall health by addressing root causes, but the results vary by individual.",
    },
    {
      question: "Are homeopathic medicines FDA approved?",
      answer:
        "Homeopathic medicines are regulated by the FDA, but they are not subjected to the same approval process as conventional drugs.",
    },
    
  ];
  
  
 export const treatments = [
    {
      id: 1,
      title: "Advanced Hair Care",
      image: advancedhair,
      alt: "XOGEN Hair Regeneration Treatment",
      url: "/home/grohair",
    },
    {
      id: 2,
      title: "Advanced Skin Care",
     
      image:advanceskincare,
      alt: "groHAIR Advanced Hair Regrowth Treatment",
      url: "/grohair",
    },
    {
      id: 3,
      title: "Dental Cosmetology",
      // description:
      //   "STM Treatment uses Korean technology to renew hair follicles.",
      image: dentalcosmetology,
      alt: "STM Treatment for Hair Growth",
      url: "/stm",
    },
  ];

 export const doctors = [
  {
    id: 1,
    name: "Dr. Spoorthi Prasad",
    specialization: "General",
    address: "BHMS |  Exp. 7+ years",
    rating: "4.5",
    image: spoorthi,
  },
  {
    id: 2,
    name: "Dr.Syed Nelofar(BHMS)",
    specialization: "skin/hair/homeopathy Specialist",
    address: "CCGO,CCH,FFAC |Exp. 5yr",
    rating: "4.7",
    image: nelofar,
  },
  {
    id: 3,
    name: "Dr.Renuka",
    specialization: "Skin Specialist",
    address: "BHMS  |  Exp. 17 years",
    rating: "4.8",
    image: renuka,
  },
  {
    id: 4,
    name: "Dr.Jyothi(BHMS)",
    specialization: "skin / hair specialist",
    address: "PGDMH, PGDCC |  Exp. 7+ years",
    rating: "4.8",
    image: jyothi,
  },
  {
    id: 5,
    name: "Dr.HariKrishna(BHMS)",
    specialization: "skin / hair specialist",
    address: "HCC,PGDCC ,DMT /EXP 1YR",
    rating: "4.5",
    image: hari,
  },
  {
    id: 6,
    name: "Dr.Priyanka Sridhar(BHMS)",
    specialization: "Skin / hair specialist",
    address: "HCC, PGDCC, DMT",
    rating: "4.5",
    image: priyanka,
  },
  {
    id: 7,
    name: "Dr.Bhargavi Giddaluru(BHMS)",
    specialization: "skin/hair/gynacology specialist",
    address: "Diploma in nutrition & fitness/ Exp 2yr",
    rating: "4.7",
    image: bargavi,
  },
  
];